import React from 'react';

import logo from '../../assets/logo_purple_title.svg';

const MainLogo = () => {
  return <img src={logo} width="317" height="252" alt="Logo" title="Logo" />;
};

export default MainLogo;
